const RATING_SNIPPET_SCRIPT_ID = 'reviews-io-rating-snippet-script';
const RATING_SNIPPET_STYLE_ID = 'reviews-io-rating-snippet-style';
const RATING_SNIPPET_CLASS = 'ruk_rating_snippet';
function loadScript() {
    if (typeof window === 'undefined') {
        return Promise.resolve();
    }
    if (typeof window.ratingSnippet === 'function') {
        return Promise.resolve();
    }
    const existingScript = document.getElementById(RATING_SNIPPET_SCRIPT_ID);
    if (existingScript) {
        return new Promise((resolve) => {
            existingScript.addEventListener('load', () => resolve(), { once: true });
            if (typeof window.ratingSnippet === 'function')
                resolve();
        });
    }
    return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.id = RATING_SNIPPET_SCRIPT_ID;
        script.src = 'https://widget.reviews.io/rating-snippet/dist.js';
        script.async = true;
        script.onload = () => resolve();
        script.onerror = () => reject(new Error('Failed to load Reviews.io rating snippet'));
        document.head.appendChild(script);
    });
}
function loadStylesheet() {
    if (typeof document === 'undefined' ||
        document.getElementById(RATING_SNIPPET_STYLE_ID)) {
        return;
    }
    const stylesheet = document.createElement('link');
    stylesheet.id = RATING_SNIPPET_STYLE_ID;
    stylesheet.rel = 'stylesheet';
    stylesheet.href = 'https://assets.reviews.io/css/widgets/rating-snippet.css';
    document.head.appendChild(stylesheet);
}
export function initReviewsIoRatingSnippets() {
    if (typeof window === 'undefined') {
        return;
    }
    loadStylesheet();
    loadScript()
        .then(() => {
        if (typeof window.ratingSnippet !== 'function')
            return;
        window.ratingSnippet(RATING_SNIPPET_CLASS, {
            store: 'minijumbuk-com-au',
            color: '#C24F18',
            text: 'Reviews',
            singularText: 'Review',
            removeBrackets: true,
            // The store matches on Shopify product ID; plain SKU lookup returns no ratings
            useCustomLookup: true,
        });
    })
        .catch((error) => {
        console.error(error);
    });
}
if (typeof window !== 'undefined') {
    window.initReviewsIoRatingSnippets = initReviewsIoRatingSnippets;
}
